import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
  LabelList,
} from "recharts";
import axios from "axios";

const SalesChart = () => {
  const [weekData, setWeekData] = useState([]);
  const [error, setError] = useState("");
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchData = () => {
      axios
        .get("./dati_dashboard.json")
        .then((res) => {
          const weekOrdersData = res.data.SUD.settimana;

          const sortedWeekData = weekOrdersData.sort(
            (a, b) => a.ordine_giorno - b.ordine_giorno
          );

          setWeekData(sortedWeekData);
        })
        .catch((err) => {
          alert(err);
          setIsError(!isError);
          setError({ err });
        });
    };

    fetchData();
  }, []);

  const today = new Date().getDay();
  const currentWeekDays = weekData.map((dataPoint) => dataPoint.it_nome_giorno);
  const opacityValues = currentWeekDays.map((day, index) =>
    // Gestione domenica: getDay() è 0, quindi mappiamo correttamente l'indice
    index < (today === 0 ? 7 : today) ? 1 : 0.3
  );

  // Funzione per calcolare e renderizzare il trend sopra la barra
  const renderTrendLabel = (props) => {
    const { x, y, width, index } = props;
    const dataItem = weekData[index];
    if (!dataItem || !dataItem.media_valore || dataItem.media_valore === 0) return null;

    const trend = ((dataItem.valore_ordinato - dataItem.media_valore) / dataItem.media_valore) * 100;
    const color = trend >= 0 ? "#28a745" : "#dc3545"; // Verde se positivo, Rosso se negativo

    return (
      <text
        x={x + width / 2}
        y={y - 10}
        fill={color}
        textAnchor="middle"
        style={{ fontSize: "0.75em", fontWeight: "bold" }}
      >
        {trend >= 0 ? "+" : ""}{trend.toFixed(1)}%
      </text>
    );
  };

  // Calcolo dinamico del massimo per evitare che le label escano dal grafico
  const maxYValue = Math.max(
    ...weekData.map((d) => Math.max(d.valore_ordinato, d.media_valore || 0))
  ) + 2000;

  return (
    <Card className="ombra border-light card-week card-home rounded-0 hover-effect">
      <div className="mt-2 mx-auto">
        <p className="text-title3 p-1">
          VALORE ORDINATO - SETTIMANALE & MEDIA 6 MESI
        </p>
      </div>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={weekData}
          margin={{
            top: 35, // Spazio per le percentuali
            right: 20,
            left: 20,
            bottom: 20,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <YAxis
            fill="black"
            className="fw-bold"
            style={{ fontSize: "0.6em" }}
            domain={[0, maxYValue]}
            tickFormatter={(value) =>
              `${parseFloat(value).toLocaleString("it-IT", {
                style: "currency",
                currency: "EUR",
                maximumFractionDigits: 0,
              })}`
            }
          />
          <XAxis
            fill="black"
            className="fw-bold"
            style={{ fontSize: "0.6em" }}
            dataKey="it_nome_giorno"
          />
          <Tooltip
            formatter={(value, name) => [
              `${parseFloat(value).toLocaleString("it-IT", {
                style: "currency",
                currency: "EUR",
              })}`,
              name,
            ]}
          />
          <Legend />
          
          <Bar dataKey="valore_ordinato" name="Valore Ordinato" fill="#b9b9b9">
            {/* Label del trend */}
            <LabelList dataKey="valore_ordinato" content={renderTrendLabel} />
            {weekData.map((entry, index) => (
              <Cell key={`cell-v-${index}`} fillOpacity={opacityValues[index]} />
            ))}
          </Bar>

          <Bar dataKey="media_valore" name="Media 6 mesi" fill="red">
            {weekData.map((entry, index) => (
              <Cell key={`cell-m-${index}`} fillOpacity={opacityValues[index]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default SalesChart;